import { apolloClient } from '~/apollo-client';
import { PaymentMethod } from '~/typings/context';
import {
  Flex_ListenForPaymentSubscription,
  Flex_ListenForPaymentSubscriptionVariables,
} from '~/typings/graphql';
import { LISTEN_FOR_PAYMENT } from './listen-for-payment.queries';

export type ListenForPaymentParams = { accountId: number };
export type ListenForPaymentResponse = { paymentMethod: PaymentMethod };

export const listenForPayment = ({
  accountId,
}: ListenForPaymentParams): Promise<ListenForPaymentResponse> => {
  const observable = apolloClient.subscribe<
    Flex_ListenForPaymentSubscription,
    Flex_ListenForPaymentSubscriptionVariables
  >({
    query: LISTEN_FOR_PAYMENT,
    variables: { accountId },
    fetchPolicy: 'no-cache',
  });
  return new Promise((resolve, reject) => {
    observable.subscribe(({ data, errors }) => {
      if (data) {
        resolve({ paymentMethod: data.paymentMethodCreated });
      } else if (errors?.length) {
        reject(new Error(errors[0].message));
      }
    });
  });
};
